<!-- Container-fluid starts-->
<div class="container-fluid" *ngIf="visible">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    <h5>Channel List</h5>
                </div>
                <div class="card-body">
                    <div class="btn-popup pull-right">
                    </div>
                    <div class="custom-datatable">
                        <form>
                            <div class="mb-3">
                                <input type='text' class="filter-ngx form-control" placeholder='Search...' [(ngModel)]="filterParams.name" (input)="applyFilter()"
                                  autocomplete="off" />
                            </div>
                        </form>
                        <button class="btn btn-primary me-1 mb-3" style="float: right;">Delete</button>
                        <div class="clearfix"></div>
                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th></th>
                                <th scope="col" sortable="id" (sort)="onSort($event)">Id</th>
                                <th scope="col" sortable="channel_id" (sort)="onSort($event)">Channel Id</th>
                                <th scope="col" sortable="name" (sort)="onSort($event)">Name</th>
                                <th scope="col" sortable="country" (sort)="onSort($event)">Country Name</th>
                                <th scope="col" sortable="owned" (sort)="onSort($event)">Owned</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let item of tableItem$ | async ">
                                <th><input type="checkbox" name="title_select" onclick="onSelect(item.id)"></th>
                                <th scope="row">{{ item.id }}</th>
                                <th scope="row">{{ item.channel_id }}</th>
                                <th scope="row">{{ item.name }}</th>
                                <th><span *ngIf="item.country != null">{{ item.country.country_name }}</span>

                                </th>
                                <td><i *ngIf="item.owned != '0'" class="fa fa-circle {{item.status}} f-12"
                                       style="color: green;">Owned</i>
                                    <i *ngIf="item.owned == '0'" class="fa fa-circle {{item.status}} f-12"
                                       style="color: red;">NotOwn</i>
                                </td>
                                <th scope="row"><a class="btn btn-primary" (click)="editChannels(item.id)">Edit</a>
                                </th>
                                <!-- <th scope="row"><a class="btn btn-primary" [routerLink]="['/pages/create-page/',item.channel_id]">Edit</a></th> -->
                                <td></td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="d-flex justify-content-center p-2">
                            <ngb-pagination
                                    [collectionSize]="(total$ | async)!" [(page)]="service.page"
                                    [pageSize]="service.pageSize">
                            </ngb-pagination>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-editpages *ngIf="!visible" [id]="editID" (visibleParentPage)="childEmitted($event)"></app-editpages>
<!-- Container-fluid Ends-->
